import React from 'react';
import PolicyPageEditor from '../PolicyPageEditor';

const ReturnPolicy = () => (
  <PolicyPageEditor pageType="return-policy" pageTitle="Return Policy" />
);

export default ReturnPolicy;
